import { AnyAction, Reducer } from 'redux';

export const STORE_COMMENTS = 'feedback/store-comment';
export const STORE_FBTYPE = 'feedback/store-fbtype';
export const STORE_RATING = 'rating/store-command';

export const STORE_FILES_SUBMITFBATTACHMENT = 'feedback/submitfb-file-attachment';
export const STORE_CHECKEDVALUE = 'checked/values-checked';
export const STORE_GENERALVALUE = 'checked/values-general';
export const STORE_ANTERIORVALUE = 'checked/values-anterior';
export const STORE_COPINGVALUE = 'checked/values-coping';
export const STORE_MODELVALUE = 'checked/values-model';
export const STORE_ABUTMENTVALUE = 'checked/values-abutment';
export const STORE_CUTBACKVALUE = 'checked/values-cutback';

export interface UserFeedback {
    transid: string;
    recid: string;
    ftype: string;
    status: string;
    foption: string;
}

export interface Column {
    Type: string;
    Params: string;
}

export interface FeedbackState {
    userFeedback: UserFeedback;
    comments: string;
    rating: number;
    General: Array<string>;
    Checked: Column[];
    Anterior: Array<string>;
    Copings: Array<string>;
    Model: Array<string>;
    Abutment: Array<string>;
    Cutback: Array<string>;
    submitFbFiles: Array<File>;
    fbtype: string;
}

const initialState: FeedbackState = {
    userFeedback: {
        transid: '',
        recid: '',
        ftype: '',
        status: '0',
        foption: ''
    },
    comments: '',
    rating: 0,
    fbtype: '',
    Checked: [],
    submitFbFiles: [],
    General: [],
    Anterior: [],
    Copings: [],
    Model: [],
    Abutment: [],
    Cutback: []
};

const reducer: Reducer<FeedbackState> = (state: FeedbackState = initialState, action: AnyAction): FeedbackState => {
    switch (action.type) {
        case STORE_COMMENTS:
            return {
                ...state,
                comments: action.comments
            };
        case STORE_FBTYPE:
            return {
                ...state,
                fbtype: action.fbtype
            };
        case STORE_RATING:
            return {
                ...state,
                rating: action.rating
            };
        case STORE_FILES_SUBMITFBATTACHMENT:
            return {
                ...state,
                submitFbFiles: action.submitFbFiles
            };
        case STORE_CHECKEDVALUE:
            return {
                ...state,
                Checked: action.payload || []
            };
        case STORE_GENERALVALUE:
            return {
                ...state,
                General: action.General
            };
        case STORE_ANTERIORVALUE:
            return {
                ...state,
                Anterior: action.Anterior
            };
        case STORE_COPINGVALUE:
            return {
                ...state,
                Copings: action.Copings
            };
        case STORE_MODELVALUE:
            return {
                ...state,
                Model: action.Model
            };
        case STORE_ABUTMENTVALUE:
            return {
                ...state,
                Abutment: action.Abutment
            };
        case STORE_CUTBACKVALUE:
            return {
                ...state,
                Cutback: action.Cutback
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/feedback.tsx